var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"footer-blurb"},[_c('div',{staticClass:"business-container"},[_c('h4',{attrs:{"tabindex":"0"}},[_vm._v(_vm._s(_vm.$t("components:content:footer-blurb:text")))])])])}
var staticRenderFns = []

export { render, staticRenderFns }